import "core-js/modules/es6.object.define-property";

var _$20$30$40$50$60$;

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

export default (_$20$30$40$50$60$ = {}, _defineProperty(_$20$30$40$50$60$, 10, '#f4f2f7'), _defineProperty(_$20$30$40$50$60$, 20, '#e3dcf7'), _defineProperty(_$20$30$40$50$60$, 30, '#cec2f0'), _defineProperty(_$20$30$40$50$60$, 40, '#b5a6e3'), _defineProperty(_$20$30$40$50$60$, 50, '#9886cf'), _defineProperty(_$20$30$40$50$60$, 60, '#7a68b3'), _defineProperty(_$20$30$40$50$60$, 70, '#645396'), _defineProperty(_$20$30$40$50$60$, 80, '#4f4178'), _defineProperty(_$20$30$40$50$60$, 90, '#3a3154'), _defineProperty(_$20$30$40$50$60$, 100, '#282436'), _$20$30$40$50$60$);